<template>
  <div class="campaigns-card d-flex fl-s-b">
    <div class="d-flex">
      <div class="d-flex fl-j-c fl-a-c picture-container">
        <img v-if="data.picture" :src="data.picture" />
        <!-- else we show the first letter -->
        <div v-else class="f-bold picture-placeholder">
          {{ data.name.charAt(0) }}
        </div>
      </div>
      <div class="d-flex flex-column fl-s-b details-container">
        <p class="f-bold">{{ data.name }}</p>
        <p class="code">{{ data.code }}</p>
        <p class="f-bold value">
          {{
            data.flatValue
              ? (data.flatValue / 100).toFixed(2)
              : `${data.percentageValue}%`
          }}
        </p>
      </div>
    </div>

    <div class="apply-button-container d-flex fl-j-c fl-a-c">
      <button
        class="apply-button d-flex fl-j-c fl-a-c"
        :class="{
          active: data.isApplied,
        }"
        @click="onToggleApplyPromocode"
      >
        {{ data.isApplied ? $t("button.applied") : $t("promocode.apply") }}
        <SvgIcon
          v-if="data.isApplied"
          :iconContent="RoundCheckIcon"
          iconAlt=""
          iconStyle="width: 18px;
        height: 18px; margin-left: 6px;"
        />
      </button>
    </div>
  </div>
</template>
<script lang="ts">
import { PropType } from "vue";
import { defineComponent } from "vue";
import { IPromocodeCardData } from "@/types/db/promocode-campaign";
import RoundCheckIcon from "@/assets/images/svg/white-round-check.svg";

export default defineComponent({
  name: "PromocodeCampaignExpandedCard",
  props: {
    data: {
      required: true,
      type: Object as PropType<IPromocodeCardData>,
    },
    toggleApplyPromocode: {
      type: Function as PropType<(data: IPromocodeCardData) => void>,
      required: true,
    },
  },
  setup(props) {
    const onToggleApplyPromocode = () => {
      props.toggleApplyPromocode(props.data);
    };

    return {
      onToggleApplyPromocode,
      RoundCheckIcon,
    };
  },
});
</script>

<style lang="scss" scoped>
@use "@/styles/variables.scss" as *;
$btns-height: 40px;

.campaigns-card {
  width: 100%;
  height: 110px;
  background-color: #fff;
  border: 1px solid rgba(229, 238, 238, 1);
  font-size: 16px;
  border-radius: 4px;
  cursor: pointer;
  color: #2a2c33;
  margin-bottom: 16px;

  .picture-container {
    height: 100%;
    aspect-ratio: 2/3;
    font-size: 24px;
    background-color: #eee;
    border-radius: 4px 0 0 4px;
    color: #2a2c33;
    img {
      object-fit: cover;
      width: 100%;
      height: 100%;
      border-radius: 4px 0 0 4px;
    }
  }

  .details-container {
    padding: 6px 8px;

    .code {
      font-size: 12px;
    }
  }

  .apply-button-container {
    padding-right: 12px;
  }
  .apply-button {
    height: 50px;
    padding: 17px 25px;
    border-radius: 4px;
    background-color: var(--primary-smeetz);
    color: #fff;
    cursor: pointer;
  }
  .active {
    background: rgba(116, 178, 183, 1);
    box-shadow: 0px -5px 1px 0px rgba(28, 138, 147, 1) inset;
  }
}
</style>
